import isEmpty from 'lodash/isEmpty';

import { RESULT_MAPPING_KEY } from '../constants';

export const getResultPageId = (campaignId: string, firstResultPage: string) => {
    const ST = window.sessionStorage;
    let resultCounts: { [resultPageId: string]: number } = {};

    try {
        // Default to '{}', not '': the result mapping is written lazily on the first answer
        // (see BrowserStorage), so a missing key is the normal state for a visitor who has
        // not answered yet. '' would make JSON.parse throw on every such navigation.
        resultCounts = JSON.parse(ST.getItem(`${RESULT_MAPPING_KEY}${campaignId}`) || '{}');
    } catch (error) {
        console.error(
            `Failed to parse JSON from Session Storage key ${RESULT_MAPPING_KEY}${campaignId}:`,
            error,
        );
    }

    // if no result counts are found, return firstResultPage
    if (!resultCounts || isEmpty(resultCounts)) {
        return firstResultPage || null;
    }

    // A tie is resolved in favour of the first result page. Only meaningful with more than
    // one candidate: the mapping is now built up lazily as answers are given, so a single
    // entry means one result page has votes and the rest have none — which is a winner, not
    // a tie. Treating it as one would send every single-answer quiz to firstResultPage.
    const counts = Object.values(resultCounts);
    const allValuesAreEqual = counts.every((val, _i, arr) => val === arr[0]);

    if (counts.length > 1 && allValuesAreEqual && firstResultPage) {
        return firstResultPage;
    }

    // Get result page with the highest count (majority voting)
    // Keep the order of the result pages consistent
    const highestCount = Object.keys(resultCounts).reduce((a, b) =>
        resultCounts[a] >= resultCounts[b] ? a : b,
    );

    if (!highestCount) {
        return firstResultPage;
    }

    return highestCount;
};
